import React from "react";
import './style.min.css'

const SliderDots = ({ number, active, onClickHandler }) => {
  // This get's the number and creates dot elements depending on the number
  const initialNO = parseInt(number)
  let dynamicNO = 1
  const activeDot = parseInt(active)
  let isActive // For adding active class on dots
  const dotsArray = []

  while (dynamicNO <= initialNO) {
    // Check if activeDot number === dynamicNO, if so then add active class to the element
    activeDot === dynamicNO ? isActive = true : isActive = false
    const el = <div
      className={`Dot ${isActive}`} key={dynamicNO*10}
      onClick={onClickHandler.bind(null, dynamicNO)}
      style={{ 
        width: '10px', height: '10px', borderRadius: '50%'
      }}
    ></div>;
    dotsArray.push(el)
    dynamicNO++
  }

  return (
  <>
    <div style={{
      width: '100px', display: 'flex', alignItems: 'center', justifyContent: 'space-between'
    }}>
      {
        dotsArray.map(dot => 
          dot
        )
      }
    </div>
  </>
)}

export default SliderDots